import { customBaseQuery } from '@/lib/baseQuery';
import { ApiResponse } from '@/types';
import { createApi } from '@reduxjs/toolkit/query/react';

export const paymentAPI = createApi({
  reducerPath: 'paymentAPI',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    createPaymentCheckout: builder.mutation<
      ApiResponse<{ redirect: string; id: string }>,
      { service_name: string; application_id: number }
    >({
      query: (body) => {
        return {
          url: '/api/payment/create-checkout/',
          method: 'POST',
          body,
        };
      },
    }),
    getPaymentList: builder.query<any, void>({
      query: () => '/api/payment/payment-information/',
    }),
    createAirwallexPaymentCheckout: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: '/api/payment/airwallex-checkout/',
          method: 'POST',
          body,
        };
      },
    }),
  }),
});

export const {
  useCreatePaymentCheckoutMutation,
  useGetPaymentListQuery,
  useCreateAirwallexPaymentCheckoutMutation,
} = paymentAPI;
